<template>
    <div class="mobile-navbar" v-outside-click="onOutsideClick">
        <MenuBlock @show-menu="showMenu = $event" :outside-click="outsideClick"/>
        <Logo/>
        <transition name="fade">
            <UserInfo v-if="showMenu"/>
        </transition>
    </div>
</template>

<script>
import Logo from "@/components/navbar/components/Logo.vue";
import MenuBlock from "./mobile/MenuBlock.vue";
import UserInfo from "./mobile/UserInfo.vue";

export default {
    name: 'MobileNavbar',
    components: {
        Logo,
        MenuBlock,
        UserInfo,
    },
    methods: {
        onOutsideClick() {
            this.outsideClick = true;
            this.$nextTick(() => this.outsideClick = false);
        }
    },
    data() {
        return {
            showMenu: false,
            outsideClick: false,
        }
    },
}
</script>
